import RichText from '../../RichText'
import type { CarouselInformativeItemTextProps } from '../carousel-informative'
import { getCustomStyles } from '../utils'

interface DescriptionProps {
  classSlide: string
  description?: CarouselInformativeItemTextProps
  textAlign: 'left' | 'right' | 'center'
}

export const Description = ({
  classSlide,
  description,
  textAlign,
}: DescriptionProps) => {
  const customStylesText = getCustomStyles(description?.styles)

  if (!description) {
    return <></>
  }

  return (
    <>
      {description?.text && (
        <div
          className={`${classSlide}-description`}
          style={{ ...customStylesText, textAlign }}
        >
          <RichText content={description?.text} />
        </div>
      )}
    </>
  )
}

export default Description
